import {AlertCircle} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const ErrorOutlineIcon = createLucideIcon(AlertCircle, 'ErrorOutlineIcon');
